import * as api from "@/api/williams/tests";
import { TestRequest } from "@/api/williams/tests";
import { useMutation } from "react-query";

export function useSubmitRequest() {
  return useMutation((request: TestRequest) => api.submitRequest(request));
}
